import { atom } from 'jotai';

import { UnsavedViewRecord } from '@/utils/exitIntentSavePrompt/exitIntentSavePrompt.types';
import { clearPending, readPending, writePending } from '@/utils/exitIntentSavePrompt/exitIntentSavePromptStorage';

/**
 * In-memory pending record + sessionStorage mirror (LAAC-2038 spec Section 8).
 * Writes always go through both; reads prefer the in-memory value.
 */
const basePendingRecordAtom = atom<UnsavedViewRecord | null>(readPending());

export const pendingRecordAtom = atom(
    (get) => get(basePendingRecordAtom),
    (_get, set, next: UnsavedViewRecord | null) => {
        if (next === null) {
            clearPending();
        } else {
            writePending(next);
        }
        set(basePendingRecordAtom, next);
    }
);

/** The record currently rendering in the prompt, or null when nothing is shown. */
// We use a typed variable instead of a bare `null` literal to ensure Jotai correctly
// identifies this as a writable PrimitiveAtom rather than a read-only Atom.
const initialActivePrompt: UnsavedViewRecord | null = null;
export const activePromptAtom = atom<UnsavedViewRecord | null>(initialActivePrompt);

/** In-memory runtime lock: true while a prompt is mounted (single-prompt exclusivity, LAAC-2038 AC 14). */
export const isPromptVisibleAtom = atom(false);

/** Timestamp the last prompt was removed from the DOM; drives the 5s cooldown (LAAC-2038 AC 15). */
export const lastPromptClosedAtAtom = atom(0);
